import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import anamnesi  from "../assets/images/monitor/cc_1_1.png";
import anamnesi2 from "../assets/images/monitor/cc_2_1.png";
import anamnesi3 from "../assets/images/monitor/cc_3_1.png";
import anamnesi4 from "../assets/images/monitor/cc_4_1.png";
import anamnesi5 from "../assets/images/monitor/cc_5_1.png";

import domanda_0 from "../assets/images/monitor/cc_1_2.png";
import domanda_1 from "../assets/images/monitor/cc_1_3.png";
import domanda_2 from "../assets/images/monitor/cc_1_4.png";

import domanda_2_0 from "../assets/images/monitor/cc_2_2.png";
import domanda_2_1 from "../assets/images/monitor/cc_2_3.png";
import domanda_2_2 from "../assets/images/monitor/cc_2_4.png";

import domanda_3_0 from "../assets/images/monitor/cc_3_2.png";
import domanda_3_1 from "../assets/images/monitor/cc_3_3.png";
import domanda_3_2 from "../assets/images/monitor/cc_3_4.png";

import domanda_4_0 from "../assets/images/monitor/cc_4_2.png";
import domanda_4_1 from "../assets/images/monitor/cc_4_3.png";
import domanda_4_2 from "../assets/images/monitor/cc_4_4.png";

import domanda_5_0 from "../assets/images/monitor/cc_5_2.png";
import domanda_5_1 from "../assets/images/monitor/cc_5_3.png";
import domanda_5_2 from "../assets/images/monitor/cc_5_4.png";

import risp_1 from "../assets/images/monitor/risp_1_2.png";
import risp_2 from "../assets/images/monitor/risp_1_2_1.png";
import risp_2_1 from "../assets/images/monitor/risp_2_1.png";
import risp_2_2 from "../assets/images/monitor/risp_2_2.png";
import risp_3_1 from "../assets/images/monitor/risp_3_1.png";
import risp_3_2 from "../assets/images/monitor/risp_3_2.png";
import risp_4_1 from "../assets/images/monitor/risp_4_1.png";
import risp_4_2 from "../assets/images/monitor/risp_4_2.png";
import risp_5_1 from "../assets/images/monitor/risp_5_1.png";
import risp_5_2 from "../assets/images/monitor/risp_5_2.png";


import avatar1 from "../assets/images/avatar01.png";
import avatar2 from "../assets/images/avatar02.png";
import avatar3 from "../assets/images/avatar03.png";
import avatar4 from "../assets/images/avatar04.png";
import avatar5 from "../assets/images/avatar05.png";
import avatar6 from "../assets/images/avatar06.png";
import avatar7 from "../assets/images/avatar07.png";
import avatar8 from "../assets/images/avatar08.png";

// Mappa delle immagini dei casi clinici
const monitorImages = {
    anamnesi: anamnesi,
    anamnesi2: anamnesi2,
    anamnesi3: anamnesi3,
    anamnesi4: anamnesi4,
    anamnesi5: anamnesi5,

    domanda_0: domanda_0,
    domanda_1: domanda_1,
    domanda_2: domanda_2,
    domanda_3: domanda_2,

    domanda_2_0: domanda_2_0,
    domanda_2_1: domanda_2_1,
    domanda_2_2: domanda_2_2,
    domanda_2_3: domanda_2_2,

    domanda_3_0: domanda_3_0,
    domanda_3_1: domanda_3_1,
    domanda_3_2: domanda_3_2,
    domanda_3_3: domanda_3_2,

    domanda_4_0: domanda_4_0,
    domanda_4_1: domanda_4_1,
    domanda_4_2: domanda_4_2,
    domanda_4_3: domanda_4_2,

    domanda_5_0: domanda_5_0,
    domanda_5_1: domanda_5_1,
    domanda_5_2: domanda_5_2,
    domanda_5_3: domanda_5_2,

    risp_1: risp_1,
    risp_2: risp_2,

    risp_2_1: risp_2_1,
    risp_2_2: risp_2_2,

    risp_3_1: risp_3_1,
    risp_3_2: risp_3_2,

    risp_4_1: risp_4_1,
    risp_4_2: risp_4_2,

    risp_5_1: risp_5_1,
    risp_5_2: risp_5_2,


};

const avatarMap = {
    avatar01: avatar1,
    avatar02: avatar2,
    avatar03: avatar3,
    avatar04: avatar4,
    avatar05: avatar5,
    avatar06: avatar6,
    avatar07: avatar7,
    avatar08: avatar8,
};

const MonitorCC = () => {
    const navigate = useNavigate();
    const [gameId, setGameId] = useState(null);
    const [monitorState, setMonitorState] = useState('anamnesi');
    const [player1, setPlayer1] = useState(null);
    const [player2, setPlayer2] = useState(null);


    // Recupera il gameId corrente
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-current-game`)
            .then(response => setGameId(response.data.gameId))
            .catch(error => console.error("Errore nel recupero del gameId:", error));
    }, []);


    // Polling dello stato del monitor per il gameId attivo
    /*useEffect(() => {
        if (gameId) {
            const fetchMonitorState = () => {
                axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-monitor-state`, {
                    params: { gameId }
                })
                    .then(response => {
                        setMonitorState(response.data.monitor);

                        if (response.data.monitor === 'gameover') {
                            navigate('/monitor-classgen');
                        }
                    })
                    .catch(error => console.error("Errore nel recupero dello stato del monitor:", error));
            };

            const intervalId = setInterval(fetchMonitorState, 3000);
            return () => clearInterval(intervalId);
        }
    }, [gameId]);*/
    // Polling dello stato del monitor sincronizzato per entrambi i giocatori

    useEffect(() => {
        if (gameId) {
            const fetchSharedMonitorState = () => {
                axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-shared-monitor-state`, {
                    params: { gameId }
                })
                    .then(response => {
                        setMonitorState(response.data.monitor);


                        if (response.data.monitor === 'gameover') {
                            navigate('/monitor-classgen');
                        }
                    })
                    .catch(error => console.error("Errore nel recupero dello stato del monitor:", error));
            };

            const intervalId = setInterval(fetchSharedMonitorState, 2000);
            return () => clearInterval(intervalId);
        }
    }, [gameId, navigate]);



    useEffect(() => {
        if (gameId) {
            const fetchPlayersInfo = () => {
                axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-players-info`, { params: { gameId } })
                    .then(response => {
                        setPlayer1(response.data.player1);
                        setPlayer2(response.data.player2);
                    })
                    .catch(error => console.error("Errore nel recupero delle informazioni dei giocatori:", error));
            };

            // Imposta un intervallo per aggiornare le informazioni dei giocatori ogni 2 secondi
            const intervalId = setInterval(fetchPlayersInfo, 2000);

            // Pulisci l'intervallo quando il componente si smonta
            return () => clearInterval(intervalId);
        }
    }, [gameId]);




    return (
        <div className="mega-screen">
            <style>
                {`
                    .mega-screen {
                        width: 100vw;
                        height: 100vh;
                        overflow: hidden;
                        /*display: flex;
                        align-items: center;
                        justify-content: center;*/
                        background-color: black;
                    }
                    .mega-screen img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover; /* Riempi l'intero schermo */
                    }
                     .player-info {
                        position: absolute;
                        bottom: 100px;
                        display: flex;
                        
                        align-items: center;
                       color:#008b8b;
                        font-size: 50pt;
                        font-weight: bold;
                    }
                    .player-info img {
                        width: 160px;
                        height: 160px;
                       padding-right:40px;
                       
                    }
                    .player1 {
                        left: 90px;
                    }
                    .player2 {
                        right: 90px;
                       
                        
                    }
                    .player-info .text {
                        display: flex;
                        align-items: center;
                        padding-right:50px;
                    }
                `}
            </style>
            {monitorState && (
                <img src={monitorImages[monitorState]} alt={`Stato monitor: ${monitorState}`}/>
            )}
            {/* Informazioni del giocatore 1 */}
            {player1 && (
                <div className="player-info player1" >
                    <img src={avatarMap[player1.avatar]} alt="" />
                    <div className="text">
                        <div>{player1.nickname}&nbsp;&nbsp;&nbsp;&nbsp;{player1.npunti}</div>
                        <div> </div>
                    </div>
                </div>
            )}

            {/* Informazioni del giocatore 2 */}
            {player2 && (
                <div className="player-info player2" style={{border: '0px solid red'}}>

                    <div className="text">
                        <div>{player2.npunti}&nbsp;&nbsp;&nbsp;&nbsp;{player2.nickname}</div>
                    </div>
                    <img src={avatarMap[player2.avatar]} alt="Avatar Giocatore 2"/>
                </div>
            )}
        </div>
    );
};

export default MonitorCC;
